import { motion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";

export function BenefitCard({
  icon,
  title,
  body,
  index,
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
  index: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={scrollRevealViewport}
      transition={{ duration: 0.45, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="bg-card group border-foreground/[0.08] relative overflow-hidden rounded-2xl border p-6"
    >
      <div
        className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 0%, color-mix(in srgb, var(--foreground) 6%, transparent), transparent 70%)",
        }}
        aria-hidden="true"
      />
      <div className="bg-foreground/10 text-brand mb-4 flex h-10 w-10 items-center justify-center rounded-xl">
        {icon}
      </div>
      <h3 className="text-foreground mb-2 text-lg font-semibold">{title}</h3>
      <p className="text-muted-foreground text-sm leading-relaxed">{body}</p>
    </motion.div>
  );
}
